<template>
  <div
    style="
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <div style="background-color: #e6edf4; padding: 10px; border-radius: 7px">
      <ul
        style="
          font-weight: 600;
          display: flex;
          align-items: center;
          line-height: 20px;
        "
      >
        {{
          props.item?.tax_month
        }}
        <li style="margin-left: 10px">
          {{ props.item?.declare_type_name }}
        </li>
      </ul>
      <ul style="font-size: 12px; color: #a2a2a2">
        {{
          props.item?.withholding_agent_name + "-" + props.item?.tax_bureau_name
        }}
      </ul>
    </div>
    <div
      style="flex: 1; display: flex; flex-direction: column; margin-top: 20px"
    >
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
      >
        <el-table-column
          prop="name"
          label="附表名称"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          prop="need_num"
          label="填写人数（应）"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          prop="actual_num"
          label="填写人数(实)"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column
          prop="amount"
          label="合计金额（元）"
          :formatter="$tab_PriceFormat"
          align="center"
        />
        <el-table-column
          prop="status"
          label="填写状态"
          :formatter="$tab_PriceFormat"
          align="center"
        >
          <template #default="{ row }">
            <template v-if="row.need">
              <text v-if="row.status == 1" style="color: #080">已填写</text>
              <text v-else>未填写</text>
            </template>
            <text v-else style="color: #a2a2a2">无需填写</text>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Edit"
              :disabled="row.need == 0"
              @click="
                state.selectItem = row;
                state.showEdit = true;
              "
            >
              填写
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-drawer
      v-model="state.showEdit"
      title="附表"
      size="80%"
      :with-header="false"
    >
      <c_TaxDeclareAttachedRecord
        v-if="state.showEdit"
        :item="state.selectItem"
        :tax_declare_id="props.item?.id"
        :declare_type="props.item.declare_type"
        :attached_type="state.selectItem?.type"
        @close="state.showEdit = false"
      ></c_TaxDeclareAttachedRecord>
    </el-drawer>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { taxdeclare_getattachedinfo } from "@/http/taxdeclare";
export default {
  props: {
    item: Object,
  },
  setup(props) {
    const state = reactive({});
    onMounted(() => {
      console.log(props);

      taxdeclare_getattachedinfo(props.item?.id).then((res) => {
        if (res.status == 200) {
          const { mssd, jmse, syjkbx, syylbx, zykcjze } = res.data.data;
          state.tableData = [
            {
              name: "免税收入",
              type: "mssd",
              ...mssd,
            },
            {
              name: "减免税额",
              type: "jmse",
              ...jmse,
            },
            {
              name: "商业健康保险",
              type: "syjkbx",
              ...syjkbx,
            },
            {
              name: "税延养老保险",
              type: "syylbx",
              ...syylbx,
            },
            {
              name: "准予扣除捐赠额",
              type: "zykcjze",
              ...zykcjze,
            },
          ];
        }
      });
    });
    return { state, props };
  },
};
</script>
<style lang="less"></style>
